import React, { useEffect, useState } from 'react';
import { loadTable, getTableData } from '../db-viewer/data/dataAccess';
import BackupDownloadPanel from './BackupDownloadPanel';

// =============================================
// DMS → Reports → Download Documents
// Thin loader that fetches the tables the backup panel needs (no file_base64 — the
// blobs are streamed server-side at download time) and renders the panel.
// =============================================

const BackupDownloadPage: React.FC = () => {
  const [users, setUsers] = useState<any[]>([]);
  const [businesses, setBusinesses] = useState<any[]>([]);
  const [folders, setFolders] = useState<any[]>([]);
  const [documents, setDocuments] = useState<any[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [u, b, f, d] = await Promise.all([
          loadTable('users'), loadTable('user_businesses'),
          loadTable('dms_folders'), loadTable('dms_documents'),
        ]);
        if (cancelled) return;
        setUsers(u); setBusinesses(b); setFolders(f);
        setDocuments(d.map((x: any) => { const { file_base64, ...rest } = x; return rest; }));
        setLoaded(true);
      } catch {
        if (cancelled) return;
        setUsers(getTableData('users')); setBusinesses(getTableData('user_businesses'));
        setFolders(getTableData('dms_folders'));
        setDocuments(getTableData('dms_documents', { omit: ['file_base64'] }));
        setLoaded(true);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const activeDocs = documents.filter(d => d.is_deleted !== 1 && d.is_active !== 0);

  if (!loaded) {
    return <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--gray-500)' }}>Loading…</div>;
  }

  return (
    <BackupDownloadPanel users={users} businesses={businesses} folders={folders} documents={activeDocs} />
  );
};

export default BackupDownloadPage;
